module.exports = __webpack_public_path__ + "img/Unidad16-7.729ff970.png";